module.exports = __webpack_public_path__ + "img/6.0149a435.jpg";